import { Button, Card, Flex, Title } from '@tremor/react'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import Sidebar from './sidebar'
import Input from '../Input'
import { useApiV1MeCreate, useApiV1MeList } from '../../api/api.gen'
import Spinner from '../Spinner'
import { getAccountHeader, setAccountHeader } from '../../api/ApiConfig'

interface ILayout {
    children: any
}

export default function Layout({ children }: ILayout) {
    const { isLoading, isExecuted, response } = useApiV1MeList()
    const {
        isLoading: updateLoading,
        isExecuted: updateExecuted,
        sendNowWithParams: updateProfile,
    } = useApiV1MeCreate({}, {}, false)

    const [name, setName] = useState('')
    const [company, setCompany] = useState('')
    const [title, setTitle] = useState('')
    const [fieldOfWork, setFieldOfWork] = useState('')
    const [phone, setPhone] = useState('')
    const [showPopup, setShowPopup] = useState(false)
    const [required, setRequired] = useState(false)
    const currentAccountID = getAccountHeader()
    const [version, setVersion] = useState(0)
    const { pathname } = useLocation()

    useEffect(() => {
        if (isExecuted && !isLoading) {
            if ((response?.name || '') === '') {
                setShowPopup(true)
            }
        }
    }, [isLoading])

    useEffect(() => {
        if (updateExecuted && !updateLoading) {
            window.location.href = '/'
        }
    }, [updateLoading])

    const shouldShowSidebar = !pathname.includes('microalgae')

    if (isLoading) {
        return (
            <Flex
                flexDirection="row"
                justifyContent="center"
                alignItems="center"
                className="h-screen w-screen"
            >
                <Spinner />
            </Flex>
        )
    }

    if (
        currentAccountID === undefined &&
        pathname.endsWith('/callback') === false
    ) {
        if (response?.accounts?.length === 1) {
            setAccountHeader(response?.accounts?.[0].id)
            setVersion(version + 1)
            return null
        }

        return (
            <Flex
                flexDirection="row"
                justifyContent="center"
                alignItems="center"
                className="h-screen w-screen"
            >
                <Card className="w-[500px]  max-w-full">
                    <Flex
                        flexDirection="col"
                        justifyContent="center"
                        className="space-y-4"
                    >
                        <Title className="mb-4">
                            Choose the account and project with which you want
                            to login to a project:
                        </Title>
                        {response?.accounts?.map((v) => (
                            <Flex className="w-fit">
                                <Button
                                    variant="secondary"
                                    color="teal"
                                    onClick={() => {
                                        setAccountHeader(v.id)
                                        setVersion(version + 1)
                                    }}
                                >
                                    {v.id}&apos;s project - your role:{' '}
                                    {v.access}
                                </Button>
                            </Flex>
                        ))}
                    </Flex>
                </Card>
            </Flex>
        )
    }

    return (
        <Flex
            flexDirection="col"
            justifyContent="start"
            className="w-screen h-screen"
        >
            <Flex
                flexDirection="row"
                alignItems="start"
                justifyContent="start"
                className="w-full h-full overflow-x-hidden"
            >
                {shouldShowSidebar && <Sidebar />}
                <Flex
                    flexDirection="col"
                    justifyContent="start"
                    alignItems="start"
                    className="w-full h-full overflow-x-auto overflow-y-auto bg-gray-200 px-4"
                >
                    {children}
                </Flex>
            </Flex>
            {showPopup && (
                <Flex
                    flexDirection="row"
                    justifyContent="center"
                    alignItems="center"
                    className="fixed top-0 left-0 w-full h-full z-50 bg-gray-600/50"
                    onClick={() => setShowPopup(false)}
                >
                    <Card
                        className="w-[500px]"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <Flex
                            flexDirection="col"
                            justifyContent="start"
                            className="space-y-2"
                        >
                            <Title>
                                Fill in your information and receive 5 OMR test
                                credit.
                            </Title>
                            <Input
                                label="Name"
                                value={name}
                                setValue={setName}
                                required={required}
                            />
                            <Input
                                label="Company"
                                value={company}
                                setValue={setCompany}
                                required={required}
                            />
                            <Input
                                label="Title"
                                value={title}
                                setValue={setTitle}
                                required={required}
                            />
                            <Input
                                label="Field of work"
                                value={fieldOfWork}
                                setValue={setFieldOfWork}
                                required={required}
                            />
                            <Input
                                label="Phone"
                                value={phone}
                                setValue={setPhone}
                                required={required}
                            />
                            <Flex justifyContent="end">
                                <Button
                                    disabled={updateExecuted && updateLoading}
                                    loading={updateExecuted && updateLoading}
                                    onClick={() => {
                                        setRequired(true)
                                        if (
                                            name.length > 0 &&
                                            company.length > 0 &&
                                            title.length > 0 &&
                                            phone.length > 0 &&
                                            fieldOfWork.length > 0
                                        ) {
                                            updateProfile(
                                                {
                                                    name,
                                                    company,
                                                    fieldOfWork,
                                                    phoneNumber: phone,
                                                    title,
                                                },
                                                {}
                                            )
                                        }
                                    }}
                                >
                                    Submit
                                </Button>
                            </Flex>
                        </Flex>
                    </Card>
                </Flex>
            )}
        </Flex>
    )
}
